/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { setupGTMConsent } from "@storybrandhq/gtm-cookie-consent"
import { hasCookieConsentLaunched } from "./src/utils/cookieConsent"

import "./src/styles/globals.css"
require("@fontsource/montserrat")
require("@fontsource/montserrat/300.css")
require("@fontsource/montserrat/400.css")
require("@fontsource/montserrat/500.css")
require("@fontsource/montserrat/600.css")
require("@fontsource/montserrat/700.css")

export const onClientEntry = () => {
  const gtmId = process.env.GATSBY_GOOGLE_TAG_MANAGER_ID
  if (!gtmId) {
    return
  }
  if (hasCookieConsentLaunched()) {
    setupGTMConsent({ gtmId })
  }
}
